const o="0.8.44",t="@openfort/openfort-js";export{t as PACKAGE,o as VERSION};
